<label
  [attr.id]="mElementId()"
  [attr.for]="for() ?? null"
  [ngStyle]="mElementStyles()"
  [ngClass]="mElementStyleClasses()"
  class="m-flex m-flex-column m-gap:2"
>
  @if (label()) {
    <span class="m-text-color:tertiary m-text-height:1 m-text-weight:bold">
      {{ label() }}
    </span>
  }

  <ng-content />
</label>
